// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-root {
    display: flex;
    flex-direction: row;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
}

.app-main {
    position: relative;
    flex: 1 1 auto;
    min-width: 0;
    height: 100vh;
    overflow: hidden;
}

.hidden {
    visibility: hidden;
}

.content-container {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
}

.map-background {
    width: 100%;
    height: 100%;
}

.hud-container {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    pointer-events: none;
}

.hud-attitude-indicator {
}

.gcs-messages-container {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 1000;
    pointer-events: none;
}

.arm-control-container {
    position: absolute;
    bottom: 10px;
    left: 10px;
    z-index: 1000;
    pointer-events: none;
}

.editor-outline {
    border: 1px solid ;
    border-radius: 3px;
    border-color: 'grey.400';
    padding: 2px;
}`, "",{"version":3,"sources":["webpack://./src/renderer/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;AACA;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,YAAY;AAChB","sourcesContent":[".app-root {\n    display: flex;\n    flex-direction: row;\n    height: 100vh;\n    width: 100vw;\n    overflow: hidden;\n}\n\n.app-main {\n    position: relative;\n    flex: 1 1 auto;\n    min-width: 0;\n    height: 100vh;\n    overflow: hidden;\n}\n\n.hidden {\n    visibility: hidden;\n}\n\n.content-container {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.map-background {\n    width: 100%;\n    height: 100%;\n}\n\n.hud-container {\n    position: absolute;\n    bottom: 10px;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 1000;\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n    pointer-events: none;\n}\n\n.hud-attitude-indicator {\n}\n\n.gcs-messages-container {\n    position: absolute;\n    top: 10px;\n    left: 10px;\n    z-index: 1000;\n    pointer-events: none;\n}\n\n.arm-control-container {\n    position: absolute;\n    bottom: 10px;\n    left: 10px;\n    z-index: 1000;\n    pointer-events: none;\n}\n\n.editor-outline {\n    border: 1px solid ;\n    border-radius: 3px;\n    border-color: 'grey.400';\n    padding: 2px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
